import {connect} from 'react-redux';
import FilesUploadStepView from '../../../components/views/mx/creditoReal/FilesUploadStepView';
import * as WizardActions from '../../../actions/WizardActions';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as ModalActions from '../../../actions/ModalActions';
import * as FileTypeConstants from '../../../../common/constants/FileTypeConstants';
import {MODAL_TYPE} from '../../../constants/ModalConstants';
import { withRouter } from 'react-router';
import {pushDataLayer} from '../../../../common/utils/GTMUtils';
import {DATA_LAYER} from '../../../../common/constants/LabelConstants';
import {BankTarget} from '../../../types/mx/types';

const mapStateToProps = (state, {match}) => {
    const files = state.creditoReal.loanApplication.files;
    const employment = state.creditoReal.loanApplication.applicantEmployment;
    const {catalogs} = state;
    const crDocumentTypeCatalog = catalogs.crDocumentType;
    const hasIncomeProof = employment.documentType && employment.documentType.id;
    const noIncomeProof = hasIncomeProof ? employment.documentType.id === '0' : true;
    const usedEmploymentDocumentType = hasIncomeProof ? crDocumentTypeCatalog.find(x => x.id === employment.documentType.id) : {payload: 0};
    const numberOfOtherDocs= usedEmploymentDocumentType?.payload && usedEmploymentDocumentType?.payload > 0 ? usedEmploymentDocumentType?.payload : 3;
    const otherMonthFilesFields = Array.from({length: numberOfOtherDocs}, (v, i) => {
        return files.other && files.other.otherMonthFiles && files.other.otherMonthFiles[i]
            ? files.other.otherMonthFiles[i]
            : [];
    })
    return {
        noIncomeProof,
        ifeFrontFiles: files.identification.ifeFrontFiles,
        ifeBackFiles: files.identification.ifeBackFiles,
        homeFiles: files.home.homeFiles,
        otherMonthFiles: otherMonthFilesFields,
        includeMonthlyIncomes: employment.includeMonthlyIncomes,
        loanApplicationToken: match.params.token
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onDropIdentificationFiles: (files, type, section, error) =>
            dispatch(WizardActions.PROCESS_FILES_TO_UPLOAD_ACTION.action(
                files, type, section, error, BankTarget.CREDITO_REAL_STATE
            )),
        onDropHomeFiles: (files, type, section, error) =>
            dispatch(WizardActions.PROCESS_FILES_TO_UPLOAD_ACTION.action(
                files, type, section, error, BankTarget.CREDITO_REAL_STATE
            )),
        onDropOtherFiles: (files, type, section, error) =>
            dispatch(WizardActions.PROCESS_FILES_TO_UPLOAD_ACTION.action(
                files, type, section, error, BankTarget.CREDITO_REAL_STATE
            )),
        onDeleteIdentificationFile: (id, type) =>
            dispatch(WizardActions.DELETE_FILE_ACTION.action(
                id, type, BankTarget.CREDITO_REAL_STATE
            )),
        onDeleteHomeFile: id =>
            dispatch(WizardActions.DELETE_FILE_ACTION.action(
                id, FileTypeConstants.HOME_TYPE, BankTarget.CREDITO_REAL_STATE
            )),
        onDeleteOtherFile: id =>
            dispatch(WizardActions.DELETE_FILE_ACTION.action(
                id, FileTypeConstants.OTHER_TYPE, BankTarget.CREDITO_REAL_STATE
            )),
        onClickThumbnail: (item) => {
            const content = {
                type: MODAL_TYPE.SHOW_FILE_IMG_VIEW,
                data: item
            };
            const options = {
                closeOnOverlayClick: true,
                size: 'small'
            };
            dispatch(ModalActions.OPEN_MODAL_DATA_ACTION.action(null, content, null, options));
        },

        onPressNext: () => {
            pushDataLayer(DATA_LAYER.UPLOAD_DOCUMENTS);
            dispatch(WizardMXActions.FINISH_LOAN_APPLICATION_ACTION.action());
        },
        onPressBack: () => dispatch(WizardMXActions.GO_TO_INSURANCES_MX_ACTION.action()),
        getLoanApplication: token => () =>
            dispatch(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_ACTION.action(token))
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
        getLoanApplication: dispatchProps.getLoanApplication(stateProps.loanApplicationToken)
    };
};

const FilesUploadStepContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(FilesUploadStepView));

export default FilesUploadStepContainer;
